<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"

    export default {
        components: {
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                formData: [
                    {
                        title: "Packing Campaign Mapping",
                        anchor: "3.1",
                        description: "Create an aggregation to combine packaging campaigns",
                        forms: [
                            {
                                label: "Mapping",
                                type: "sectionarray",
                                value: "packingCampaign.mappings",
                                grid: "grid-50w",
                                buttonText: "Add mapping",
                                forms: [{
                                    type: "guid",
                                    value: "id"
                                }, {
                                    type: "text",
                                    label: "Name",
                                    value: "name",
                                    required: true
                                }, {
                                    type: "typeahead",
                                    label: "Select studies",
                                    value: "studies",
									appendAll: true,
                                    required: true,
                                    multiple: true,
                                    preValues: {
                                        field: "studies",
                                        name: "name",
                                        value: "id"
                                    },
                                    callback: (formValue) => {
                                        // Cleanup selected values when deleting items
                                        this.aggregationCleanSelected(formValue, "dispensingUnitDataSources");
                                    }
                                }, {
                                    type: "aggregationtable",
                                    label: "Aggregation",
                                    value: "studies",
                                    extraClass: "grid-full",
                                    searchPlaceholder: "Search studies",
                                    valueGroup: "dispensingUnitDataSources",
                                    rows: (table) => {
                                        let list = [];
                                        for(let tg of table.data.treatmentGroups)
                                        for(let dun of tg.dispensingUnits){
											var dunName = table.data.dispensingUnits.find(x=>x.id==dun.id).name;
                                            list.push({
                                                id: table.studyId + "_" + table.forecastVersionId + "_" + tg.id + "_" + dun.uniqueId,
                                                dunId: dun.id,
                                                dunName: dunName,
                                                dunUniqueId: dun.uniqueId,
                                                treatmentGroupName: tg.name,
                                                treatmentGroupId: tg.id
                                            });
                                        }

                                        return list;
                                    },
                                    forms: [{
                                        type: "label",
                                        name: "DUN",
                                        value: "dunName",
                                        valueId: "dunUniqueId",
                                        valueGroup: "dispensingUnit"
                                    },{
                                        type: "label",
                                        name: "Treatment Group",
                                        value: "treatmentGroupName",
                                        valueId: "treatmentGroupId",
                                        valueGroup: "treatmentGroup"
                                    }]
                                }]
                            }
                        ]
                    }
                ]
            }
        }
    }
</script>
